import Vue from 'vue'
import Router from 'vue-router'
import index from '../view/index'
import Login from '../view/Login'
import Product from '../view/Product'
import ProductCopy from '../view/ProductCopy'
import Shopping from "../view/Shopping"
import Information from '../view/Information'
import OrdersIn from '../view/OrdersIn'
import Product_List from '../view/Product_List'
import question from '../view/question'
import Callme from '../view/Callme'
import Security from '../view/Security'
import Search from "../view/Search"
import Authorization from '../view/Authorization'
import ForgotPwd from '../view/ForgotPwd'
import ResetPwd from '../view/ResetPwd'
import Account from '../view/Account'
import Orders_i from '../view/Orders_i'
import Brand from '../view/Brand'
import Pay from '../view/Pay'
import NewDetail from '../view/NewDetail'
import Brand_authority from '../view/Brand_authority'
import Brandhistory from '../view/Brandhistory'
import customer from '../view/customer'
import Addcity from '../view/Addcity'
import wxPayWaiting from '../view/wxPayWaiting'
import collection from '../view/collection.vue'
import otherLogin from '../view/otherLogin.vue'
import binding from '../view/binding'
Vue.use(Router)
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const routers = new Router({
  mode: 'history',  //去掉url中的#
  linkExactActiveClass: 'active',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index
    },
    {
      path: '/Login',
      name: 'Login',
      component: Login
    },
    {
      path: '/Product',
      name: 'Product',
      component: Product
    },
    {
      path: '/ProductCopy',
      name: 'ProductCopy',
      component: ProductCopy
    },
    {
      path: '/Shopping',
      name: 'Shopping',
      component: Shopping
    },
    {
      path: '/Information',
      name: 'Information',
      component: Information
    },
    {
      path: '/OrdersIn',
      name: 'OrdersIn',
      component: OrdersIn
    },
    {
      path: '/Product_List',
      name: 'Product_List',
      component: Product_List
    },
    // {
    //   path: '/question',
    //   name: 'question',
    //   component: question
    // },
    {
      path: '/Callme',
      name: 'Callme',
      component: Callme
    },
    {
      path: '/Security',
      name: 'Security',
      component: Security
    },
    {
      path: '/Search',
      name: 'Search',
      component: Search
    },
    {
      path: '/Authorization',
      name: 'Authorization',
      component: Authorization
    },
    {
      path: '/ForgotPwd',
      name: 'ForgotPwd',
      component: ForgotPwd
    },
    {
      path: '/ResetPwd',
      name: 'ResetPwd',
      component: ResetPwd
    },
    {
      path: '/Account',
      name: 'Account',
      component: Account
    },
    {
      path: '/Orders_i',
      name: 'Orders_i',
      component: Orders_i
    },
    {
      path: '/Brand',
      name: 'Brand',
      component: Brand
    },
    {
      path: '/Pay',
      name: 'Pay',
      component: Pay
    },
    {
      path: '/NewDetail',
      name: 'NewDetail',
      component: NewDetail
    },
    {
      path: '/Brand_authority',
      name: 'Brand_authority',
      component: Brand_authority
    },
    {
      path: '/Brandhistory',
      name: 'Brandhistory',
      component: Brandhistory
    },
    {
      path: '/customer',
      name: 'customer',
      component: customer
    },
    {
      path: '/Addcity',
      name: 'Addcity',
      component: Addcity
    },
    {
      path: '/collection',
      name: 'collection',
      component: collection
    },
    {
      path: '/wxPayWaiting',
      name: 'wxPayWaiting',
      component: wxPayWaiting
    },
    {
      path: '/otherLogin',
      name: 'otherLogin',
      component: otherLogin
    },
    {
      path: '/binding',
      name: 'binding',
      component: binding
    }
  ],
  scrollBehavior(to, from,savedPosition) {
    return { x: 0, y: 0 }
  }
})

routers.beforeEach(function(to, from, next) {
  // 临时禁用、。。。。。。。。。。。。。。。。。。。。。。
  // window.fullscreenLoadingF()


  
  // if (!localStorage.getItem("loginName")) {
  //     if (to.path !== '/login') {
  //         return next('/login')
  //     }
  // }
  next()
})

export default routers


// WEBPACK FOOTER //
// ./src/router/index.js